import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import ProductiveCycleForm from '../Forms/ProductiveCycleForm';

const AddEditProductiveCycleModal = ({
	dataProductiveCycle,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
}) => {

	const [allowConfigStages, setAllowConfigStages] = useState();

	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Ciclo Productivo
			</ModalHeader>

			<div className='modal-content border-0 mt-3'>
				<Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
					<NavItem>
						<NavLink href='#' className={classnames({ active: activeTab === '1' })} onClick={() => { toggleTab('1'); }}>
							Información General
						</NavLink>
					</NavItem>
					{
						(allowConfigStages ? 
							<NavItem>
								<NavLink href='#' className={classnames({ active: activeTab === '2' })} onClick={() => { toggleTab('2'); }}>
									Configurar Etapas
								</NavLink>
							</NavItem> :
							null
						)
					}
					
				</Nav>
			</div>

			<ProductiveCycleForm
				dataProductiveCycle={dataProductiveCycle}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				handleAllowConfigStages={setAllowConfigStages}
			/>
		</Modal>
	);
};

export default AddEditProductiveCycleModal;
